import React from 'react';
import { ServicePackageCard } from '../../shared';

const ServicesTab = ({ service }) => {
  return (
    <div>
      <h3 className="marketing-display-md mb-6 text-m-ink">Service packages</h3>
      <div className="space-y-4">
        {service?.vendor_service_packages?.length > 0 ? (
          service.vendor_service_packages.map((pkg) => (
            <ServicePackageCard key={pkg.id} package={pkg} />
          ))
        ) : (
          <div className="rounded-2xl border border-m-border-light bg-m-surface py-10 text-center">
            <p className="text-sm text-m-ink-muted">
              No service packages available for this service.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ServicesTab;
